module.exports = __webpack_public_path__ + "static/media/mark-highlighter.55149808.svg";